/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PolygonCollection_jsonld } from './PolygonCollection_jsonld';
import type { TileCollection_jsonld } from './TileCollection_jsonld';
import type { ValueObject_Location_jsonld } from './ValueObject_Location_jsonld';
export type GeoPolygon_GeoPolygonDocument_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    geoId?: string;
    geoType?: GeoPolygon_GeoPolygonDocument_jsonld.geoType;
    polygons?: PolygonCollection_jsonld | null;
    tiles?: TileCollection_jsonld | null;
    center?: ValueObject_Location_jsonld | null;
    isUserDefinedLocation?: boolean;
    readonly userDefinedLocation?: boolean;
};
export namespace GeoPolygon_GeoPolygonDocument_jsonld {
    export enum geoType {
        CITY = 'city',
        VOIVODESHIP = 'voivodeship',
        REGION = 'region',
        COUNTRY = 'country',
    }
}
